export default __webpack_public_path__ + "static/media/reset_icon.131b0891.svg";